app.factory('nfzOfficeModel', ['$rootScope', 'baseModel', 'nfzOfficeService',
    function ($rootScope, baseModel, nfzOfficeService) {

        function NfzOfficeModel() {

            this.getDataPage = function (criteria) {
                return nfzOfficeService.getDataPage(criteria).then(
                    function (dataPage) {
                        $rootScope.$broadcast(Event.NFZ_OFFICE.GET_DATA_PAGE.SUCCESS, dataPage);
                        return dataPage;
                    },
                    function (error) {
                        $rootScope.$broadcast(Event.NFZ_OFFICE.GET_DATA_PAGE.ERROR, error);
                    }
                )
            };
        }

        return new NfzOfficeModel();
    }
]);
